import React from "react";
import { Icon } from "~/components/Icon";
import Layout from "~/components/Layout";

const Impressum = () => {
    return (
        <Layout title="Sportision - Impressum">
            <div className="container">
                <div className="jumbotron">
                    <h1 className="display-4">Impressum</h1>
                    <h5 className="mt-2 mb-4">Angaben gemäß § 5 TMG:</h5>
                    <h3>
                        <Icon className="mr-3 pb-1" width="30" height="30" alt="" />
                        Sportision GmbH
                    </h3>
                    <ul className="list-unstyled ml-1">
                        <li>Langenwiedenweg 121</li>
                        <li>59457 Werl</li>
                        <li>Deutschland</li>
                    </ul>

                    <div className="my-3">
                        <h5 className="font-weight-bold">Kontakt</h5>
                        <div className="row">
                            <div className="col-1 tw-font-bold">Telefon:</div>
                            <div className="col-11">+49 2922 875144 0 (Telefonnummer nur von Sportision)</div>
                        </div>
                        <div className="row">
                            <div className="col-1 tw-font-bold">Email:</div>
                            <div className="col-11">
                                <a href="mailto:info@sportision.de">info@sportision.de</a>
                            </div>
                        </div>
                    </div>

                    <div className="my-3">
                        <h5 className="font-weight-bold">Geschäftsführer</h5>
                        <ul className="list-unstyled">
                            <li>Mike Hesse</li>
                            <li>Johannes Macha</li>
                        </ul>
                    </div>

                    <div className="my-3">
                        <h5 className="font-weight-bold">Registereintrag</h5>
                        <p>
                            Handelsregister des Amtsgerichts Arnsberg
                            <br />
                            Registernummer: <b>HRB 12945</b>
                        </p>
                    </div>

                    <div className="my-3">
                        <h5 className="font-weight-bold">Umsatzsteuer-Identifikationsnummer</h5>
                        <p>Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz: DE326068577</p>
                    </div>

                    <div className="my-3">
                        <h5 className="font-weight-bold">Haftungsausschluss (Disclaimer)</h5>
                        <p>
                            <b>Haftung für Inhalte</b>
                            <br />
                            Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach
                            den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter
                            jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen
                            oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
                            Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den
                            allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst
                            ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden
                            von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
                        </p>
                        <p>
                            <b>Haftung für Links</b>
                            <br />
                            Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen
                            Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
                            Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der
                            Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf
                            mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung
                            nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne
                            konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von
                            Rechtsverletzungen werden wir derartige Links umgehend entfernen.
                        </p>
                        <p>
                            <b>Urheberrecht</b>
                            <br />
                            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem
                            deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
                            Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung
                            des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den
                            privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht
                            vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere
                            werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine
                            Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei
                            Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
                        </p>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default Impressum;
